import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/auth-store';

/**
 * Gate inserted INSIDE `RequireAuth` and OUTSIDE the layout so a user with
 * `must_change_password=true` (an admin generated a temp password) is forced to
 * the change-password screen before any creator studio route can render. The
 * change-password route is mounted outside this gate so it stays reachable.
 */
export function RequirePasswordChange() {
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}
